import * as React from 'react';
import { actionCreator, dispatchAction } from '@ardoq/rxbeach';
import { toggleCollapse } from './scenarioRelatedDataSource$';
import { isMac } from '@ardoq/common-helpers';
import {
  selectClick,
  selectMeta,
  selectShift,
} from './scenarioRelatedSelection$';
import { DataSourceItem } from './types';
import { ArdoqId } from '@ardoq/api-types';
import { showScopeRelatedNavigator } from '../../actions';
import { trackClickRelatedComponents } from 'scope/tracking';

export const addComponentsToScenarioAction = actionCreator<{
  componentIds: ArdoqId[];
}>('[scenarioRelated] add components to scenario');

export const includeComponentFromGraphClicked = actionCreator<{
  componentId: ArdoqId;
}>('[scenarioRelated] include component from graph clicked');

export const removeComponentsFromScenarioAction = actionCreator<{
  componentIds: ArdoqId[];
}>('[scenarioRelated] remove components from scenario');

export const select =
  (id: string, dataSource: DataSourceItem[]) =>
  async (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    dispatchAction(showScopeRelatedNavigator());
    if (isMac() ? event.metaKey : event.ctrlKey) {
      dispatchAction(selectMeta(id));
      trackClickRelatedComponents('control');
    } else if (event.shiftKey) {
      dispatchAction(selectShift({ id, dataSource }));
      trackClickRelatedComponents('shift');
    } else {
      dispatchAction(selectClick(id));
      trackClickRelatedComponents('none');
    }
  };

export const toggle =
  (id: string) => (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.stopPropagation();
    dispatchAction(toggleCollapse(id));
  };

export const addComponentsToScenario = (componentIds: ArdoqId[]): void => {
  dispatchAction(addComponentsToScenarioAction({ componentIds }));
};

export const removeComponentsFromScenario = (componentIds: ArdoqId[]): void => {
  dispatchAction(removeComponentsFromScenarioAction({ componentIds }));
};
